import { formRequiredRules } from '../../../../../lib/formRules';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import { ValidationRule, WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';
import { EventWidgetDetailV2 } from '../../../../../types/widget';
import { validateStringLength } from '../../../../../lib/utils/form/validators';

type EventWidgetFormRuleReturnType = {
  mainTitle: { rules: ValidationRule[] };
  subTitle: { rules: ValidationRule[] };
  memo: { rules: ValidationRule[] };
  eventWidgetListTable: { hideIf: boolean };
  widgetItemEvents: {
    rules: ValidationRule[];
    innerRules: {
      event: {
        rules: ValidationRule[];
      };
      mobileImage: {
        rules: ValidationRule[];
      };
      pcImage: {
        rules: ValidationRule[];
      };
      memo: {
        rules: ValidationRule[];
      };
    };
  };
};

export const useEventWidgetFormRules = (form: WrappedFormUtils): EventWidgetFormRuleReturnType => {
  const { widgetItemEvents } = form.getFieldsValue(['widgetItemEvents']) as Pick<
    EventWidgetDetailV2,
    'widgetItemEvents'
  >;

  return {
    mainTitle: {
      rules: [
        formRequiredRules(true, REQUIRED_MSG),
        { validator: validateStringLength({ max: 20, message: '위젯 타이틀의 글자 수는 최대 20자입니다' }) },
      ],
    },
    subTitle: {
      rules: [
        { validator: validateStringLength({ max: 20, message: '위젯 서브 타이틀의 글자 수는 최대 20자입니다.' }) },
      ],
    },
    memo: {
      rules: [{ validator: validateStringLength({ max: 1000, message: '메모는 최대 글자 수는 1,000자입니다.' }) }],
    },
    eventWidgetListTable: {
      hideIf: !widgetItemEvents?.length,
    },
    widgetItemEvents: {
      rules: [{ required: true, type: 'array', message: REQUIRED_MSG }],
      innerRules: {
        event: {
          rules: [{ required: true, type: 'object', message: REQUIRED_MSG }],
        },
        mobileImage: {
          rules: [{ required: true, type: 'array', message: REQUIRED_MSG }],
        },
        pcImage: {
          rules: [{ required: true, type: 'array', message: REQUIRED_MSG }],
        },
        memo: {
          rules: [
            formRequiredRules(true, REQUIRED_MSG),
            { validator: validateStringLength({ max: 250, message: '메모는 최대 글자 수는 250자입니다.' }) },
          ],
        },
      },
    },
  };
};
